<template>
    <div class="menu-block">
        <div class="menu-header" :style="{'background-color':$store.state.page.bg_color?$store.state.page.bg_color:'#bd3a73','color':$store.state.page.text_color?$store.state.page.text_color:'#fff'}">
            {{title}}
        </div>
        <div class="menu-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['title']
    }
</script>

<style scoped lang="scss">
    .menu-block{
        font-size:12px;
        margin-right:15px;
        margin-bottom:15px;

        @media screen and (max-width: 768px){
            width:100%;
        }

        .menu-header{
            padding:2px 5px;
        }

        .menu-content{
            border: solid 1px #e9dddd;
            ul{
                list-style: none;
                margin:0px;
                padding:10px;

                li{
                    padding: 5px 0px;

                    a{
                        cursor:pointer;
                    }
                }
            }

        }       
    }
</style>